import api from './api';
import { API_CLIENT_DOMAIN } from '../constants';
import { handleError } from '../errorHandler';

export const getIntegration = (onSuccess: Function, onFailure: Function) => {
  api
    .get(API_CLIENT_DOMAIN + '/integration')
    .then((response) => onSuccess(response.data))
    .catch((error) => handleError(error, onFailure));
};

export const activateIntegration = (
  onSuccess: Function,
  onFailure: Function
) => {
  api
    .post(API_CLIENT_DOMAIN + '/integration/activate')
    .then((response) => onSuccess(response.data))
    .catch((error) => handleError(error, onFailure));
};

export const createSecondarySecretKey = (
  onSuccess: Function,
  onFailure: Function
) => {
  api
    .post(API_CLIENT_DOMAIN + '/integration/secret')
    .then((response) => onSuccess(response.data))
    .catch((error) => handleError(error, onFailure));
};

export const deleteSecondarySecretKey = (
  onSuccess: Function,
  onFailure: Function
) => {
  api
    .delete(API_CLIENT_DOMAIN + '/integration/secret')
    .then((response) => onSuccess(response.data))
    .catch((error) => handleError(error, onFailure));
};

export const switchSecondarySecretKey = (
  onSuccess: Function,
  onFailure: Function
) => {
  api
    .put(API_CLIENT_DOMAIN + '/integration/secret')
    .then((response) => onSuccess(response.data))
    .catch((error) => handleError(error, onFailure));
};
